import React from 'react';
import { PropTypes } from 'prop-types';
import { makeStyles } from '@material-ui/core';

const styles = makeStyles({
    wrapper: {
        padding: ({ hasParent }) => hasParent && '0.5em 1.2em',
        gridColumn: 'span 3'
    },
    container: ({ align, hasParent }) => ({
        textAlign: align ? align : 'initial',
        padding: !hasParent && '0 16px',
        width: '100%',
        display: 'block',
        margin: '.5em 0',
        '& > p  *': {
            fontFamily: 'inherit !important',
            fontSize: '13px !important',
            fontWeight: 'normal !important',
            background: 'transparent !important',
            color: 'black !important'
        }
    })
});

const Description = ({ field }) => {
    const { description, presentation } = field;
    const hasParent = !!field?.parent;
    const classes = styles({ align: presentation.alignment, hasParent });
    return (
        <div className={classes.wrapper}>
            <p className={classes.container} dangerouslySetInnerHTML={{ __html: description }} />
        </div>
    );
};

Description.propTypes = {
    field: PropTypes.object
};
export default Description;
